import { useEffect, useState } from 'react';
import CountryData from 'data/country.json'
import SignUpHeader from './Header';
import { ISignUpComponents, ITerms } from 'types/signup';
import { ReactComponent as ArrowRight } from 'assets/signup/arrowRight.svg'
import { ReactComponent as CheckOn } from 'assets/common/checkOn.svg'
import { ReactComponent as CheckOff } from 'assets/common/checkOff.svg'
import { ReactComponent as Check } from 'assets/common/check.svg'
import CustomSelect, { ISelectOption } from 'components/common/CustomSelect';
import { termsContent } from 'data/terms';
import TermsModal from 'components/common/modal/TermsModal';

const First = ({ signUpInfo, setSignUpInfo, setClear }: ISignUpComponents) => {
    const [selected, setSelected] = useState<ISelectOption>({} as ISelectOption)
    const [option, setOption] = useState<ISelectOption[]>([])

    const [all, setAll] = useState<boolean>(false);
    const [require, setRequire] = useState<boolean>(false);
    const [terms, setTerms] = useState<ITerms[]>([
        {
            id: 0,
            title: 'PulseOnShip 이용약관 동의',
            content: termsContent[0],
            chk: false,
            required: true,
        },
        {
            id: 1,
            title: '개인정보 수집 및 이용 동의',
            content: termsContent[1],
            chk: false,
            required: true,
        },
        {
            id: 2,
            title: '마케팅 정보 수신 동의',
            content: termsContent[1],
            chk: false,
            required: false,
        },
    ]);
    const [popOpen, setPopOpen] = useState<boolean>(false);
    const [selectTerms, setSelectTerms] = useState<ITerms>({} as ITerms)

    useEffect(() => {
        if (signUpInfo.termsAgree && signUpInfo.termsAgree.length > 0) {
            setTerms(prev =>
                prev.map((term, idx) => ({
                    ...term,
                    chk: signUpInfo.termsAgree[idx] ?? false,
                }))
            );
        }

        const mapped: ISelectOption[] = CountryData.map(item => ({
            value: item.id || '',
            label: item.ko,
            labelEn: item.en
        }));
        setOption(mapped);
    }, []);

    useEffect(() => {
        setSignUpInfo(prev => ({
            ...prev,
            regionCode: selected.value
        }));
    }, [selected])

    useEffect(() => {
        setClear(require && selected.value !== undefined)
    }, [require, selected])

    useEffect(() => {
        const termsAgree = terms.every(arr => arr.chk);
        const requireAgree = terms
            .filter(term => term.required)
            .every(term => term.chk);
        setAll(termsAgree);
        setRequire(requireAgree);

        setSignUpInfo(p => ({
            ...p,
            termsAgree: terms.map(term => term.chk)
        }));
    }, [all, terms, require])

    // 전체 약관 체크
    const allChk = () => {
        setAll(p => {
            if (p) {
                setRequire(false);
            }
            return !p
        });
        setTerms(p => {
            const temp = [...p]
            temp.map(arr => arr.chk = !all)
            return temp
        })
    }

    // 필수 약관 체크
    const requireChk = () => {
        setRequire(!require);
        setTerms(t => {
            const temp = [...t]
            temp.map(arr => arr.required ? arr.chk = !require : arr.chk)
            return temp
        })
    }

    // 약관 팝업 오픈
    const openTermPop = (item: ITerms) => {
        // getPolicy().then(res => {
        //     console.log(res.data)
        // })
        setSelectTerms(item)
        setPopOpen(true)
    }

    // 약관 조회
    // const getPolicy = async () => {
    //     const url = `${process.env.REACT_APP_API_URL}policy`
    //     return await axios.get(url)
    // }

    return (
        <>
            <SignUpHeader title={'이용약관 동의'} idx={1} />
            <div className='flex flex-col gap-3 mb-8'>
                <p className='font-semibold mobile:text-base text-lg'>
                    소속 국가
                </p>

                <CustomSelect
                    option={option}
                    placeholder={'소속 국가를 선택해주세요'}
                    setSelected={setSelected}
                />
            </div>

            <div className='flex flex-col gap-3 mb-4.5 mobile:mb-2'>
                <p className='font-semibold mobile:text-base text-lg'>
                    서비스 이용약관 동의
                </p>
                <div
                    className='bg-[#F8F8FA] px-6 mobile:px-4 rounded-lg h-15 mobile:h-10 mobile:text-sm text-xl'
                >
                    <label
                        htmlFor='allCheck'
                        className='flex justify-between items-center h-full cursor-pointer'>
                        이용약관 전체동의

                        {
                            all ?
                                <CheckOn className='mobile:w-6 mobile:h-6' /> :
                                <CheckOff className='mobile:w-6 mobile:h-6' />
                        }
                        <input
                            className="hidden accent-primary"
                            type="checkbox"
                            name=""
                            id="allCheck"
                            checked={all}
                            onChange={allChk}
                        />
                    </label>
                </div>
            </div>

            <div className='mb-3 mobile:mb-2 px-6 mobile:px-4 rounded-lg h-15 mobile:h-10 mobile:text-sm text-xl'>
                <label
                    htmlFor='requireCheck'
                    className='flex justify-between items-center h-full cursor-pointer'>
                    필수약관 전체동의

                    {
                        require ?
                            <CheckOn className='mobile:w-6 mobile:h-6' /> :
                            <CheckOff className='mobile:w-6 mobile:h-6' />
                    }
                    <input
                        className="hidden accent-primary"
                        type="checkbox"
                        name=""
                        id="requireCheck"
                        checked={require}
                        onChange={requireChk}
                    />
                </label>
            </div>

            <div className='flex flex-col gap-3 mb-8 mobile:mb-6 px-6 mobile:px-4 text-[#A4A4A4] mobile:text-sm text-lg'>
                {
                    terms.map((item: ITerms, idx: number) => (
                        <div
                            className='flex justify-between items-center'
                            key={idx}>
                            <div
                                className={`flex gap-1 cursor-pointer hover:text-primary hover:underline transition-all duration-300 ${item.chk && 'text-black'}`}
                                onClick={() => openTermPop(item)}
                            >
                                {
                                    item.required ? <p className='text-primary'>[필수] </p> : <p>[선택] </p>
                                }
                                {item.title}
                            </div>
                            <div className='h-8'>
                                {
                                    item.chk ?
                                        <Check
                                            className='mobile:w-6 cursor-pointer'
                                            onClick={() => {
                                                setTerms(t => {
                                                    const temp = [...t]
                                                    temp[idx].chk = !temp[idx].chk
                                                    return temp
                                                })
                                            }}
                                        /> :
                                        <p>
                                            <ArrowRight
                                                className='mobile:w-6 cursor-pointer'
                                                onClick={() => {
                                                    setTerms(t => {
                                                        const temp = [...t]
                                                        temp[idx].chk = !temp[idx].chk
                                                        return temp
                                                    })
                                                }}
                                            />
                                        </p>
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
            {/* 약관 팝업 */}
            <TermsModal
                isOpen={popOpen}
                setIsOpen={setPopOpen}
                title={selectTerms.title}
                content={selectTerms.content}
            />
        </>
    )
}

export default First